module.exports = __webpack_public_path__ + "static/media/wedding-party.fa5b631d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/wedding-party.svg
// module id = 965
// module chunks = 68